import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  public showSuccess(message: string): void {
    this.messageService.add({ severity: 'success', summary: 'Erfolgreich', detail: message });
  }

  public showError(message: string): void {
    this.messageService.add({ severity: 'error', summary: 'Fehler', detail: message });
  }

  public showInfo(message: string): void {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
  }

  public showWarn(message: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Warnung', detail: message });
  }

  public clearAll() {
    this.messageService.clear();
  }
}
